<script lang="ts" setup>
import AppLoading from '~/components/AppLoading.vue'

defineProps({
  hasMatterInfo: { type: Boolean }
})

const emit = defineEmits(["click:runPredict"])
</script>

<template>
  <WCard class="no-prediction">
    <template v-if="hasMatterInfo">
      <h2 class="styled strong step-3">
        Get Started
      </h2>
      <p>
        It looks like you have not made any predictions yet.
      </p>
      <WButton text="Run PREDiCT" @click="emit('click:runPredict')" />
      <p>to get started</p>
    </template>
    <template v-else>
      <h2 class="styled strong step-3">
        Just a sec
      </h2>
      <p>
        We are getting your matter details...
      </p>
      <AppLoading class="loading-spinner" />
    </template>
  </WCard>
</template>

<style lang="scss" scoped>
.no-prediction {
  padding: var(--space-l);
  margin: var(--space-l);
  text-align: center;
  display: flex;
  flex-direction: column;
  gap: var(--space-s);
  width: calc(100% - var(--space-l) * 2);
  place-items: center;
}
.loading-spinner {
  --app-loading-spinner-color: var(--app-color-secondary);
}
</style>
